<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<h1><strong>Isabella or Guns, Dollars, Cotton and<br/>
Sterling</strong></h1>
<p>Sold into slavery to one of the last British ships before it was abolished in 1807, the surgeon of the slaver Eva is besotted by Isabel; bids and wins her at the slave market in Savannah; escaping with her to Boston where he becomes a wealthy doctor.</p>
<p>On his death, Isabel takes her maid Molly to Niagara Falls, Canada, in 1863 on hearing that it is the destination of the underground railway, wishing to help fleeing slaves from the south.</p>
<p>In New York, Agnatha, a well-connected abolitionist lady, persuades her nephew; who is in love with a southern girl returning to her parents plantation; to join the Union navy. Then hearing of Isabel, sets off to Cincinnati to establish a travel agency helping escaping slaves on their way to Lake Erie. In Liverpool, two brothers, the sons of a cotton importer; travel to America with their sister to provide a pathway for guns in and cotton out. The sister, sympathetic to women’s liberation and the plight of the slaves, agrees to take a young girl to safety up the Mississippi into Canada. She meets Agnatha and Molly, and discovers the awful truth that her grandfather possibly had a connection with Isabel.</p>
<p>Isabel charters a ship to bring slaves to safety across Lake Erie, and allows Molly to go on the first ship. Molly returns hanging on to the arms of a Canadian doctor working on behalf of the government; as the rescued slaves tumble ashore and kiss the ground in relief, but it is all too much for Isabel.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?3c69bb9d